@if (orga$ | async; as orga) {
  <div class="flex flex-col gap-8">
    @if (archive$ | async; as archive) {
      <app-document-folder-card
        [archive]="archive"
        [disabled]="!(hasPermission$ | async)"
        (updateArchiveFolders)="updateArchive($event)"
      ></app-document-folder-card>
    }
    <app-document-category-card
      [categories]="(categories$ | async)!"
      (updateCategories)="updateCategories($event)"
    ></app-document-category-card>
    @if (
      orga.data.subscription?.plan === 'business' || orga.data.subscription?.plan === 'enterprise'
      ) {
      <app-document-mail-card
        [orga]="orga.data"
        [disabled]="!(hasPermission$ | async)"
        (mailAdressChanged)="settingsChanged($event)"
      ></app-document-mail-card>
    }
  </div>
}
